import React from 'react';
import './describeEquipamentPageStyle.css';
import './../../components/contentBlock/contentBlockStyles.css'
import useSetSiteLanguage from '../../hooks/useSetSiteLanguage';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer/footer';
import ContentBlock from '../../components/contentBlock/contentBlock';
import EquipamentTable from '../../components/equipamentTable/equipamentTable';
import H2Title from './../../components/text/h2Title/h2Title'

export default function DescribeEquipamentPage() {
    const params = useParams();
    const siteContent = useSetSiteLanguage();

    console.log("params: ", params)
    const id = params.idundefined

    return (
        <>
            <Navbar data={siteContent?.navbar}/>
            <div className='describe-equipament-page__container'>
            <H2Title title={siteContent?.equipamentsPage?.equipaments[id]?.name} color={"white"}/>
                <ContentBlock 
                    text={siteContent?.equipamentsPage?.equipaments[id]?.summary} 
                    type="photo-right" 
                    photo={siteContent?.equipamentsPage?.equipaments[id]?.photo} 
                />

                <ContentBlock 
                    text={siteContent?.equipamentsPage?.equipaments[id]?.application}
                    title={siteContent?.equipamentsPage?.equipaments[id]?.applicationTitle}
                />

            </div>
            <Footer 
                email={siteContent?.contactSection?.email}
                linkedin={siteContent?.contactSection?.linkedin}
                whatsapp={siteContent?.contactSection?.whatsapp}/>
        </>
    );
}
